import React from "react";
import { StyledTableCell } from "../../../../styles/Shipmentstyles";
import { Box, SxProps, TableSortLabel, Theme } from "@mui/material";
import { SortType } from "../../../../models/SortType";
import sort from "../../../../assets/Sort.png";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface AppTableHeaderCellPops {
  title?: string;
  sx?: SxProps<Theme>;
  fontSize?: string;
  minWidth?: string;
  sortColumn?: string;
  sortBy?: string;
  sortDirection?: SortType;
  onSortChange?: (sortColumn: string, sortType: SortType) => void;
  children?: React.ReactNode;
  fontColor?: string;
  fontWeight?: number;
  txtAlign?: "left" | "center" | "right";
}

const AppTableHeaderCell = ({
  title,
  sx,
  fontSize = "0.9rem",
  minWidth = "180px",
  sortColumn,
  sortBy,
  sortDirection,
  onSortChange,
  children,
  fontColor = "#93969B",
  fontWeight = 600,
  txtAlign = "center",
}: AppTableHeaderCellPops) => {
  const renderSortIcon = () => {
    if (sortBy === sortColumn) {
      return sortDirection === SortType.ASC ? (
        <FontAwesomeIcon icon={faArrowUp} fontSize={"0.7rem"} color="#000000" />
      ) : (
        <FontAwesomeIcon
          icon={faArrowDown}
          fontSize={"0.7rem"}
          color="#000000"
        />
      );
    }

    return (
      <Box sx={{ display: "flex", gap: "2px" }}>
        <FontAwesomeIcon icon={faArrowUp} fontSize={"0.6rem"} />
        <FontAwesomeIcon icon={faArrowDown} fontSize={"0.6rem"} />
      </Box>
    );
  };

  return (
    <>
      {sx === undefined ? (
        <StyledTableCell
          sx={{
            textAlign: txtAlign,
            minWidth,
            fontSize: fontSize,
            color: fontColor,
            fontWeight: fontWeight,
          }}
        >
          {onSortChange === undefined ||
          sortBy === undefined ||
          sortDirection === undefined ||
          sortColumn === undefined ? (
            children ? (
              children
            ) : (
              title
            )
          ) : (
            <TableSortLabel
              active={sortBy === sortColumn}
              direction={sortDirection === SortType.ASC ? "asc" : "desc"}
              onClick={() =>
                onSortChange(
                  sortColumn,
                  sortColumn === sortBy && sortDirection === SortType.DESC
                    ? SortType.ASC
                    : SortType.DESC,
                )
              }
              IconComponent={() => (
                <span
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "4px",
                  }}
                >
                  {renderSortIcon()}
                </span>
              )}
              sx={{
                fontSize: fontSize,
                fontWeight: fontWeight,
                color: "#93969B",
                "&.Mui-active": {
                  color: "#93969B",
                },
              }}
            >
              {children ? children : title}
            </TableSortLabel>
          )}
        </StyledTableCell>
      ) : (
        <StyledTableCell
          sx={{
            textAlign: txtAlign,
            minWidth,
            fontSize: fontSize,
            color: fontColor,
            fontWeight: fontWeight,
            justifyContent: txtAlign === "center" ? "center" : txtAlign,
            ...sx,
          }}
        >
          {onSortChange === undefined ||
          sortBy === undefined ||
          sortDirection === undefined ||
          sortColumn === undefined ? (
            children ? (
              children
            ) : (
              title
            )
          ) : (
            <TableSortLabel
              active={sortColumn === sortBy}
              direction={sortDirection === SortType.ASC ? "asc" : "desc"}
              onClick={() =>
                onSortChange(
                  sortColumn,
                  sortColumn === sortBy && sortDirection === SortType.DESC
                    ? SortType.ASC
                    : SortType.DESC,
                )
              }
              IconComponent={() => (
                <span
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "4px",
                  }}
                >
                  {renderSortIcon()}
                </span>
              )}
              sx={{
                fontSize: fontSize,
                fontWeight: fontWeight,
                color: "#93969B",
                "&.Mui-active": {
                  color: "#93969B",
                },
              }}
            >
              {children ? children : title}
            </TableSortLabel>
          )}
        </StyledTableCell>
      )}
    </>
  );
};

export default React.memo(AppTableHeaderCell);
